import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import map from 'lodash/map';

import { UnwrapArray } from '@sbv-clients/util-misc';

import {
  LaborLevelApiLaborLevelFacilitiesGetRequest,
  LaborLevelCacheKeys,
  useApi,
} from '../index';

export const useLaborLevelFacilitiesGet = (
  laborLevelApiLaborLevelFacilitiesGetRequest?: LaborLevelApiLaborLevelFacilitiesGetRequest
) => {
  const api = useApi();
  return useQuery({
    queryKey: [
      LaborLevelCacheKeys.Facilities,
      laborLevelApiLaborLevelFacilitiesGetRequest,
    ],
    queryFn: () =>
      api.laborLevelApi
        .laborLevelFacilitiesGet(laborLevelApiLaborLevelFacilitiesGetRequest)
        .then((response) => response?.data ?? []),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export type FacilityResponseType = NonNullable<
  UnwrapArray<ReturnType<typeof useLaborLevelFacilitiesGet>['data']>
>;

export const useLaborLevelFacilityOptionsGet = () => {
  const { data = [], isLoading, isSuccess } = useLaborLevelFacilitiesGet();
  const options = useMemo(
    () =>
      map(data, (item) => ({
        id: item.facilityId as number,
        label: item.facilityName ?? '',
        value: item.facilityId as number,
      })),
    [data]
  );

  return { options, isLoading, isSuccess };
};
